export default __webpack_public_path__ + "static/media/fireworks.01b7ed74.mp4";